import { Card, CardBody, CardTitle, Container, Row, Col, Button, Table, Badge, Spinner } from 'reactstrap';
import { useEffect, useState } from "react";
import axios from "axios";
import BarChart from 'pages/Allcharts/chartjs/barchart';
import { co } from '@fullcalendar/core/internal-common';

export const QBBalanceSheetGraph = ({ alertMsgg, setAlertMsgg, setshowloader }: { alertMsgg: any, setAlertMsgg: React.Dispatch<React.SetStateAction<any>>, setshowloader: React.Dispatch<React.SetStateAction<any>> }) => {

    const [balanceSheetInfo, setBalanceSheetInfo] = useState<Record<string, any> | null>(null);
    const [balanceSheetGraphData, setBalanceSheetGraphData] = useState<Record<string, any>[]>([]);
    const [balanceSheetQuery, setBalanceSheetQuery] = useState<Record<string, any>>({
        date_macro: "Last Fiscal Year",
        accounting_method: "Cash",
        summarize_column_by: "Month",
    });

    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const fetchProfitLossInfo = async (query: Record<string, any>) => {
        try {
            setshowloader(true);
            const response = await axios.post(
                `/assignments/api/balanceSheet/`,
                { query },
                { withCredentials: true }
            );
            if (response && response.reconnect_required) {
                setAlertMsgg({ ...alertMsgg, open: true, content: response.error || "QuickBooks token expired. Please reconnect.", type: "error" });
                setshowloader(false);
                return null;
            }
            if (response && response.status === "SENT") {
                console.log("Balance Sheet Info: ", response);
                setshowloader(false);
                return response.report;
            }
            setshowloader(false);
        } catch (error: any) {
            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                    setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data?.error || "Error occurred", type: "error" });
                } else if (error.response.status === 403) {
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(() => { window.location.href = "/logout"; }, 2000);
                } else {
                    setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            } else {
                setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            setshowloader(false);
        }
        setshowloader(false);
    }

    const getBalanceSheetInfo = async () => {
        const balanceSheetinfo = await fetchProfitLossInfo(balanceSheetQuery)
        if (!balanceSheetinfo) return;
        setBalanceSheetInfo(balanceSheetinfo);
        var netIncome = balanceSheetinfo?.Rows.Row.at(-1).Summary.ColData;
        var data: Record<string, any>[] = [];
        netIncome.slice(1, -1).map((item: any, index: number) => {
            const value = parseInt(item.value);
            data.push({
                month: months[index],
                profOrLoss: value,
                color: value > 0 ? 'green' : 'red'
            });
        });
        setBalanceSheetGraphData(data);

    };

    useEffect(() => {
        getBalanceSheetInfo();
    }, []);

    useEffect(() => {
        getBalanceSheetInfo();
    }, []);

    return (
        <Card>
            <CardBody>
                <CardTitle>Balance Sheet</CardTitle>
                <h6><b>Filters</b>: Coming Soon</h6>
                {balanceSheetInfo ? (
                    <div className="stack align-stretch my-sm">
                        <BarChart
                            data={{
                                labels: balanceSheetGraphData.map((item) => item.month),
                                datasets: [
                                    {
                                        label: "Costs & Expenses",
                                        borderWidth: 1,
                                        data: balanceSheetGraphData.map((item) => item.profOrLoss),
                                    },
                                ],
                            }}
                        />
                    </div>
                ) : (
                    <Spinner color="primary" />
                )}
            </CardBody>
        </Card>
    );
};